export default {
  LOCAL_API_URL: "http://localhost:8050",
  LOCAL_URL: "http://localhost:8051",
  LOCAL_PDF_URL: "http://localhost:8050/pdf/generate-pdf",
  STAGING_API_URL: "https://api.bdgdemo.5stage.club",
  STAGING_URL: "https://bdgdemo.5stage.club",
  STAGING_PDF_URL: "https://pdf.bdgdemo.5stage.club/pdf/generate-pdf",
  PROD_API_URL: "https://api.berghoffapp.com",
  PROD_URL: "https://berghoffapp.com",
  PROD_PDF_URL: "https://pdf.berghoffapp.com/pdf/generate-pdf"
};
